import type { Metadata } from '@cigna/shared/metadata-util';
import { HttpHeaders } from '@angular/common/http';
/**
 * Interface for the 'Appstate' data
 */
export interface GetNavigationsResponse {
  data?: NavigationResponse;
  metadata?: Metadata;
}
export interface GetBrNavigationsResponse {
  data?: BrNavigationResponse;
  metadata?: Metadata;
}
export interface SecureAppState {
  Navigation: NavigationResponse;
}

export interface NavigationResponse {
  bearer?: string;
  clients: Clients[];
  email: string;
  firstName: string;
  agencyName?: string;
  isNpnPilot?: boolean;
  impersonated?: boolean;
  impersonatorId?: string;
  lastAccessedInternalProcGrpId?: string;
  lastName: string;
  middleName?: string;
  middleInit?: string;
  mobile?: string | null;
  phone?: string;
  ssoId: string;
  ssoIdEnc: string;
  uid?: string;
  userAgreementAccepted?: boolean;
  userType?: string;
  userTypeCd?: string;
  serTypeCd?: string;
  isInternalUser: boolean;
  hasClientManaged?: boolean;
  migrationStatus?: string;
  defaultPlatform?: string;
  defaultClientid?: number;
  userTypeInd?: string;
  telephoneNumber?: string;
}
export interface BrNavigationResponse {
  isNpnPilot?: boolean;
  bearer?: string;
  email?: string;
  firstName: string;
  navigation?: Navigation;
  roles?: Role[];
  impersonated?: boolean;
  impersonatorId?: string;
  lastAccessedInternalProcGrpId?: string;
  lastName: string;
  middleName?: string;
  middleInit?: string;
  mobile?: string | null;
  phone?: string;
  ssoId: string;
  ssoIdEnc: string;
  uid?: string;
  userAgreementAccepted?: boolean;
  userType?: string;
  userTypeCd?: string;
  serTypeCd?: string;
  isInternalUser: boolean;
  hasClientManaged?: boolean;
  migrationStatus?: string;
  defaultPlatform?: string;
  isBroker?: boolean;
  telephoneNumber?: string;
  partyRoles?: string | undefined;
  agencyNames?: string | undefined;
}
export interface ToolsResponse {
  contentType: string;
  contents: ToolsContent[];
}
export interface ToolsContent {
  id: string;
  category: string;
  subcategory: string;
  content: Tool;
  metadata: { priority: string };
}
export interface Tool {
  item: ToolItem;
}
export interface ToolItem {
  body: string;
  'ext-url': boolean;
  'link-text': string;
  'link-url': string;
  'url-target': string;
}

export interface Clients {
  cs1id: number;
  id: string;
  name: string;
  dlgLevel: number;
  chatCode: number;
  sourceCode: string;
  lob: string;
  migrationStatus?: string;
  roles?: string[];
  navigation?: Navigation;
  internalProcGrpId?: string | number;
  productType?: { productTypeCd: string; productType: string };
}
export interface SearchedClientItem {
  cs1id?: number;
  clientId: string;
  clientName: string;
  effectiveDate?: string;
  idManager?: string;
  lob: string | null;
  status?: string;
  source: string;
  clientActivationStatus?: string;
  productType?: { productTypeCd: string; productType: string };
}
export interface RoleList {
  roleList: string[];
}

export interface Navigation {
  entitlements: string[];
  menus: Menu[];
}
export interface Menu {
  entitlementId: number;
  entitlement: string;
  sortOrder: number;
  isExternal: boolean;
  subMenus?: SubMenu[];
}
export interface Role {
  brokerId: string;
  lob: string;
  producerCode: string;
  roleId: string;
}
export interface SubMenu {
  l3Menus?: any;
  entitlement: string;
  sortOrder: number;
  isExternal: boolean;
  parentEntId: number;
}

export interface SearchClientResponse {
  data?: SearchedClientItem[];
  metadata?: Metadata;
}

export interface CheckIpValidResponse {
  data?: CheckIpValid;
  metadata?: Metadata;
}

export interface CheckIpValid {
  valid: boolean;
}

export interface CheckIpValidRequest {
  groupId?: string;
  sourceCode?: string;
  ipAddress?: string;
  service_reference_id?: string;
}

export interface SearchClientRequest {
  searchType: string;
  searchValue: string;
}

export interface GroupItem {
  text: string;
  id: string;
  cs1id?: string;
  internalProcGrpId: string;
  source: string;
  migrationStatus?: string;
  displayKeyFull?: string | null;
}

export interface SearchByItem {
  id: string;
  name: string;
}
export interface AlertRequest {
  callArea: string;
  suppress_response_code?: boolean;
  service_reference_id?: boolean | string;
}
export interface AlertResponse {
  data?: AlertInfo;
  metadata?: Metadata;
}
export interface AlertInfo {
  contentType: string;
  contents: ContentInfo[];
}
export interface ContentInfo {
  content: Content;
  alertSeen: boolean;
  isDismissed?: boolean;
}
export interface Content {
  alertMsgId: string;
  header: string;
  body: string;
  cta_list?: CtaList[];
}
export interface CtaList {
  cta_text: string;
  cta_url: string;
}
export interface AlertDismissRequest {
  alertMsgId: string[];
}
export interface UserAgreeAcceptParam {
  agreementStatus: string;
  userSegment: string;
}
export interface UserAgreeAcceptResponse {
  data?: null;
  metadata?: Metadata;
}
export interface UserAgreementResponse {
  data?: UserAgreementInfo;
  metadata?: Metadata;
}
export interface UserAgreementInfo {
  contentType: string;
  contents: UserAgreementContentInfo[];
}
export interface UserAgreementContentInfo {
  content: UserAgreementContent;
}
export interface UserAgreementContent {
  description: string;
  header: string;
}

export interface UserType {
  code: string;
  description: string;
}

export interface WelcomeTileType {
  header?: string | ' ';
  img?: string | ' ';
  body?: string | ' ';
  btnText?: string | '';
  btnUrl?: string | '';
  btnTarget?: string | '';
}
export interface GetWelcomeTileResponse {
  contentType: string;
  contents: WecomeContent[];
  metadata?: Metadata & { environment?: string };
}
export interface WecomeContent {
  id: string;
  category: string;
  subcategory: string;
  content: WcContentType;
  metadata: {
    priority: string;
  };
  env?: string | undefined;
}
export interface WcContentType {
  item: {
    body: string;
    'cta-text': string;
    'cta-url': string;
    'ext-url': boolean;
    header: string;
    'image-url': string;
    'url-target': string;
  };
}

export const USER_TYPE: UserType[] = [
  {
    code: 'PA',
    description: 'Plan Administrator',
  },
  {
    code: 'PR',
    description: 'Producer',
  },
  {
    code: 'VN',
    description: 'Vendor',
  },
  {
    code: 'BT',
    description: 'Bots',
  },
  {
    code: 'CN',
    description: 'Cigna Employee - Non sales',
  },
  {
    code: 'CS',
    description: 'Cigna Employee - Sales',
  },
  {
    code: 'UN',
    description: 'Unknown',
  },
];

export interface DelegationLevel {
  code: number;
  description: string;
}

export const DELEGATION_LEVEL: DelegationLevel[] = [
  {
    code: 2,
    description: 'Primary Administrator',
  },
  {
    code: 1,
    description: 'Secondary Administrator',
  },
  {
    code: 0,
    description: 'Associate',
  },
];

export enum Entitlement {
  QuoteandEnrollTile = 'tile-quote-enroll',
  QaEIFPMedical = 'ifp-medical',
  QaEIFPMedicalExtAgent = 'ifp-medical-ext-agent',
  QaEIFPMedicalIntAdmin = 'ifp-medical-int-adm',
  QaEIFPMedicalExtAgency = 'ifp-medical-ext-agency',
  QaEIFPDental = 'ifp-dental',
  QaEMedicareAdvantage = 'medicare-advantage',
  QaEMaLeon = 'ma-leon',
  QaECignaSupplementalBenefits = 'cigna-supp-benefits',
  QaEMedicareAdvantage2022 = 'medicare-advantage-2022',
  QaEMedicareAdvantage2023 = 'medicare-advantage-2023',
  BookOfBusiness = 'tile-book-business',
  BoBCommercial = 'commercial',
  BoBIndividualandFamilyPlans = 'ifp-book-business',
  BoBMA = 'ma-book-business-ext',
  BoBMAInt = 'ma-book-business-int',
  BoBMaApplicationStatusExt = 'ma-applic-status-ext',
  BoBMaApplicationStatusInt = 'ma-applic-status-int',
  BoBCignaSupplementalBenefits = 'csb-book-business',
  BoBNewCignaSupplementalBenefits = 'csb-book-business-new',
  CompensationTitle = 'tile-compensation',
  SgpCompensationTitle = 'sgp-compensation',
  CommercialCompensationStatements = 'commercial-compensation',
  CTRequestAccess = 'commercial-req-access',
  RequestforInformation = 'tile-req-information',
  RfIViewallRFI = 'ma-view-all-rfi-ext',
  RfIViewallRFIInt = 'ma-view-all-rfi-int',
  RfIViewApplicantRFI = 'ma-view-applicant-ext',
  ToolsTile = 'tile-tools',
  SmenuComCompensation = 'smenu-com-compensation',
  SmenuMaCompensation = 'smenu-ma-compensation',
  SmenuSgpCompensation = 'smenu-sgp-compensation',
  IfpAdmin = 'smenu-ind-administration',
  UsempRfp = 'smenu-com-req-proposal',
  UsempMarketingMaterial = 'smenu-com-solutions-insights',
  UsempPlanProductTranHub = 'smenu-com-training',
}

export interface EntitlementLob {
  entitlement: Entitlement;
}

export interface ImpersonatorSignOutResponse {
  body?: ImpersonatorSignOutData;
  headers?: HttpHeaders;
  status?: string;
  statusText?: string;
  ok?: string;
  url?: string;
}

export interface ImpersonatorSignOutData {
  operation: string;
}
export interface InstantALertData {
  contents: BusinessAlertContents[];
}
export interface AlertContentData {
  body: string;
  priority: number;
  category: string;
  lob?: string;
  color?: string;
  width?: string;
  padding?: string;
  fontColor?: string;
  contactUs?: boolean;
  subText?: string;
  link?: {
    text: string;
    url: string;
    target: string;
  };
}
export interface BusinessAlertContents {
  content: BusinessAlertContent;
}
export interface BusinessAlertContent {
  item: AlertContentData;
}
export interface CategoryType {
  categoryName: string;
  className: string;
}
export interface UpdateUserLoginDateResponse {
  data?: null;
  metadata?: Metadata;
}

export interface Onboarding {
  basicInfo: OnboardingBasicInfo[];
  addressInfo: OnboardingAddressInfo[];
  isCommercialOpted?: boolean;
  isIfpOpted?: boolean;
  isMaOpted?: boolean;
  isCsbOpted?: boolean;
  isContinueCommercial?: boolean;
  isContinueIfp?: boolean;
  isContinueMa?: boolean;
  commercial: OnBoardingCommercial[];
  ifp: OnBoardingIfp[];
  ma: OnBoardingMa[];
  csb: OnBoardingCsb[];
}

export interface OnboardingBasicInfo {
  firstName: string;
  lastName: string;
  emailAddress: string;
  mobileNumber?: string;
  npn?: number;
  agencyName?: string;
}

export interface OnboardingAddressInfo {
  physicalAddress: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zipCode: number;
  };
  mailingAddress: {
    street1: string;
    street2?: string;
    city: string;
    state: string;
    zipCode: number;
  };
  isSameAsPhysical?: boolean;
}

export interface OnBoardingCommercial {
  isExistingOpportunity?: boolean;
  employerName: string;
  noOfEmployee: string;
  workState: string;
}

export interface OnBoardingIfp {
  isLicensedCt: boolean;
  producerstate: string;
  statesLicensed: string;
}

export interface OnBoardingMa {
  isLicensedCt: boolean;
  producerstate: string;
  statesLicensed: string;
}

export interface OnBoardingCsb {
  isLicensedCt: boolean;
  producerstate: string;
  statesLicensed: string;
}

export interface FormattedTool {
  text: string;
  icon: string;
  route: string;
  isExternal: boolean;
  priority: string;
  isTool: boolean;
  entitlement: string;
}
